import { createFileRoute, Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";
import { lookupChainOfCustody } from "@/lib/chain-of-custody.functions";
import { useScope } from "@/hooks/use-scope";
import { PageHeader } from "@/components/ui/page-header";
import { Badge } from "@/components/ui/badge";

export const Route = createFileRoute("/_authenticated/app/traceability/$ref")({ component: TraceRefPage });

function TraceRefPage() {
  const { ref } = Route.useParams();
  const { tenantId } = useScope();
  const lookupFn = useServerFn(lookupChainOfCustody);
  const { data, isLoading } = useQuery({
    queryKey: ["coc", tenantId, ref],
    enabled: !!tenantId,
    queryFn: () => lookupFn({ data: { tenantId: tenantId!, query: ref } }),
  });

  return (
    <>
      <PageHeader title={`Chain of custody — ${ref}`}
        description="Every recorded touch for this serial or lot."
        meta={<Link to="/app/compliance/trace" className="text-xs text-primary underline">New lookup →</Link>} />
      <div className="px-4 sm:px-6 py-4 space-y-4">
        {isLoading && <div className="text-sm text-muted-foreground">Loading…</div>}
        {data && (
          <div className="border rounded-md bg-card">
            <div className="p-3 border-b text-sm font-medium">Timeline ({data.events.length})</div>
            <ol className="divide-y">
              {data.events.map((e, i) => (
                <li key={i} className="px-3 py-2 flex items-start gap-3 text-sm">
                  <span className="text-xs text-muted-foreground tabular-nums w-44 shrink-0">{new Date(e.at).toLocaleString()}</span>
                  <Badge variant="outline" className="shrink-0">{e.source}</Badge>
                  <div className="flex-1">
                    <div>{e.label}</div>
                    {e.detail && <div className="text-xs text-muted-foreground">{e.detail}</div>}
                  </div>
                </li>
              ))}
              {data.events.length === 0 && <li className="px-3 py-6 text-center text-muted-foreground text-sm">No events found.</li>}
            </ol>
          </div>
        )}
      </div>
    </>
  );
}